module.exports = __webpack_public_path__ + "static/Pheal-Logo-White-3bba37032e42db897c80b21f94dd1b2c.png";